import { styled } from '@portfolio/styles'
import { useLayoutEffect, type MouseEvent } from 'react'
import { useTranslation } from 'react-i18next'

const SkipLink = styled('a', {
  projectFont: 'ui01',
  position: 'absolute',
  top: '20px',
  left: '50%',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '220px',
  height: '$buttonHeight',
  padding: '2px 24px 0 24px',
  borderRadius: '$rMax',
  backgroundColor: '$black',
  color: '$white',
  textAlign: 'center',
  textDecoration: 'none',
  whiteSpace: 'nowrap',
  transform: 'translate(-50%, -300px)',
  transition: 'transform 0.3s, background 0.2s',
  zIndex: '$skipLink',

  '&:focus': {
    transform: 'translate(-50%, 0)',
  },

  '&:focus-visible': {
    outline: '$focusBlue solid 3px',
    transform: 'translate(-50%, 0)',
  },
})

const focusMainContent = () => {
  const main = document.getElementById('main')
  if (!main) return

  main.focus({ preventScroll: true })
  main.scrollIntoView({ block: 'start' })
}

const stripMainHashFromUrl = () => {
  if (window.location.hash !== '#main') return

  window.history.replaceState(
    window.history.state,
    '',
    `${window.location.pathname}${window.location.search}`,
  )
}

export const SkipToMainContent = () => {
  const { t } = useTranslation('accessibility')

  useLayoutEffect(() => {
    if (window.location.hash !== '#main') return

    stripMainHashFromUrl()
    focusMainContent()
  }, [])

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    focusMainContent()
  }

  return (
    <SkipLink href="#main" onClick={handleClick}>
      {t('skipToMainContent')}
    </SkipLink>
  )
}
